const studyStore = {
  namespaced: true,

  state: {
    mainStudyInfo: null,
    date:'',
    getPlanItem: {},
    getPlanHistList: [],
    getStudyPlan:[],
    getGuideData:[],
    getGuidePage:1,
    scheduleDate:''
  },

  getters: {
    getDate(state) {
      return state.date;
    },
    getMainStudyInfo(state) {
      return state.mainStudyInfo;
    },
    getPlanItem(state) {
      return state.getPlanItem;
    },
    getPlanHistList(state) {
      return state.getPlanHistList;
    },
    getStudyPlan(state) {
      return state.getStudyPlan
    },
    getGuideInfo(state) {
      return state.getGuideData
    },
    getGuidePage(state) {
      return state.getGuidePage
    },
    getStudyScheduleDate(state) {
      return state.scheduleDate;
    }
  },

  mutations: {
    updateDate(state, list) {
      state.date = list;
    },
    updateMainStudyInfo(state, list) {
      state.mainStudyInfo = list;
    },
    updatePlanItem(state, item) {
      state.getPlanItem = item;
    },
    updatePlanHistList(state, list) {
      state.getPlanHistList = list;
    },
    updateStudyPlan(state,info) {
      state.getStudyPlan = info;
    },
    updateGuideInfo(state,info) {
      state.getGuideData = info;
    },
    updateGuidePage(state,info) {
      state.getGuideData = info;
    },
    updateStudyScheduleDate(state, date) {
      state.scheduleDate = date;
    },
  },

  actions: {
  }
}

export default studyStore